import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container border mt-4"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col m-4" }
const _hoisted_4 = { class: "free-trial" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" You are currently on a ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Free Trial", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "free-trial-days ps-2" }
const _hoisted_9 = {
  key: 1,
  class: "container border mt-4"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col m-4" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "plan-title-1" }, "Thank you for trying OTC Pro"),
    /*#__PURE__*/_createTextVNode("You've reached the end of your free trial period. We really hope you enjoyed using OTC Pro and have "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("gained an understanding of the value that real-time scanning has on your trading success. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("To continue using OTC Pro please select one of our plans. ")
  ])
], -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.user.subscription?.state !== 'expired')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _createTextVNode(" until " + _toDisplayString(_ctx.user.subscription?.currentPeriodEndDate) + " ", 1),
                _createElementVNode("span", _hoisted_8, "(" + _toDisplayString(_ctx.user.subscription?.daysRemaining) + " days remaining)", 1)
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
  ]))
}